<div class="content">
  <div class="icon-bg" [ngClass]="{'flex-center': center}" [ngStyle]="styleObject">
    <span class="material-symbols-outlined text-hint" style="font-size: {{fontSize}}; margin: {{margin}}">{{icon}}</span>
  </div>
  <ng-content></ng-content>
</div>

